module.exports = __webpack_public_path__ + "static/media/ui-switch.ed348664.png";